export default "__VITE_ASSET__Cejmrb24__"